import { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import SLPArtistsHow1 from '../../assets/slpArtists/slpArtistsHow1.png';
import SLPArtistsHow2 from '../../assets/slpArtists/slpArtistsHow2.png';
import SLPArtistsHow3 from '../../assets/slpArtists/slpArtistsHow3.png';
import SLPArtistsHow4 from '../../assets/slpArtists/slpArtistsHow4.png';
import ListArtstyleButton from './SLPArtistsListArtstyleButton';

export const SLPArtistsHow = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const ethicalCreationData = {
    title:
      'AI content is rshaping our cultural and economic landscape, yet questions around ownership and ethics remain pressing. Saagas tackles these challenges using ',
    highlightedTitle: 'and FairGen',
    sections: [
      {
        title: <>Upload Your Portfolio</>,
        description: 'Submit 12–20 cohesive artworks that represent a specific style, theme or character.',
        images: [SLPArtistsHow1]
      },
      {
        title: <>Set Price and Publish</>,
        description: 'Set price to offer it on the marketplace for others to use or use it yourself privately.',
        images: [SLPArtistsHow2]
      },
      {
        title: 'Get Paid Automatically',
        description: <>Every image download using your art style for personal or commercial use triggers a payment to your Stripe account.</>,
        images: [SLPArtistsHow3]
      },
      {
        title: 'Monitor Your Income',
        description: <>Your style keeps earning even when you’re offline.</>,
        images: [SLPArtistsHow4]
      }
    ],
    footerText:
      'Working in tandem, FairEx and FairGen enable AI Creators and Brands to ethically source required digital content, then use those to create personalized commercial content with full legal protection.'
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % ethicalCreationData.sections[0].images.length);
    }, 4000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      id="slp-artists-how"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        background:"#151515",
        px: { xs: '24px', md: 4, lg: 4 }
      }}
    >
      <Typography
        component="h1"
        variant="h3"
        fontFamily="Inter"
        id="how-it-works"
        sx={{
          fontWeight: 700,
          fontSize: { xs: '24px', sm: '24px', md: '40px' },
          lineHeight: '100%',
          letterSpacing: '0px',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 1)',
          mt: 5.5,
          mb: 4,
          [theme.breakpoints.down('md')]: {
            mb: 3
          }
        }}
      >
        How it Works?{' '}
      </Typography>

      <Typography
        component="h1"
        variant="h3"
        fontFamily="Inter"
        sx={{
          fontWeight: 500,
          fontSize: { xs: '16px', sm: '16px', md: '28px' },
          lineHeight: '100%',
          letterSpacing: '0px',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 1)',
          mb: 2,
          [theme.breakpoints.down('md')]: {
            mb: 3
          }
        }}
      >
        List, License, Earn{' '}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          [theme.breakpoints.down('md')]: {
            gap: '10px'
          }
        }}
      >
        {ethicalCreationData.sections.map((section, index) => {
          const isEven = index % 2 === 0;
          const currentImage = section.images[currentImageIndex];

          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                width: { xl: 1260 },
                height: { xl: 484 },
                gap: '35px',
                alignItems: 'center',
                mt: 9,
                mb: 2,
                flexDirection: isEven ? 'row' : 'row-reverse',
                flexWrap: 'wrap',
                [theme.breakpoints.down('md')]: {
                  flexDirection: 'column',
                  width: '100%',
                  height: 'auto',
                  gap: '10px',
                  mt: 1,
                  mb: 1
                }
              }}
            >
              {/* Title for mobile */}
              <Typography
                component="h2"
                variant="h4"
                fontFamily="Inter"
                sx={{
                  display: { xs: 'block', md: 'none' },
                  fontWeight: 500,
                  fontSize: '20px',
                  color: '#FFFFFF',
                  mt: '16px',
                  mb: '16px',
                  textAlign: 'center',
                  lineHeight: '120%'
                }}
              >
                {section.title}
              </Typography>

              {/* Image */}
              <Box sx={{ flex: 2, width: '100%', height: { xs: '250px', sm: '300px', md: '350px', lg: '400px', xl: '484px' } }}>
                <Box
                  component="img"
                  src={currentImage}
                  alt={`Section ${index + 1} Image`}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'fit',
                    borderRadius: '10px',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                    transition: 'background-image 1s ease-in-out',
                    border: ' 1px solid #c0c0c0'
                  }}
                />
              </Box>

              {/* Text content for desktop */}
              <Box
                sx={{
                  flex: 1,
                  display: { xs: 'none', md: 'flex' },
                  flexDirection: 'column',
                  textAlign: 'left',
                  maxWidth: { xs: '100%', lg: 352 },
                  px: { xs: 1, sm: 2, md: 3, lg: 0 }
                }}
              >
                <Typography
                  component="h2"
                  variant="h4"
                  fontFamily="Inter"
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: '20px', md: '20px', lg: '29.03px' },
                    color: '#c0c0c0',
                    mt: { xs: '16px' }
                  }}
                >
                  {section.title}
                </Typography>
                <Typography
                  variant="h5"
                  fontFamily="Inter"
                  sx={{
                    fontWeight: 300,
                    fontSize: { xs: '14px', md: '16.8px' },
                    color: '#C0C0C0',
                    mt: { xs: '12px', md: 3 },
                    maxWidth: { xs: '100%', lg: 315 }
                  }}
                >
                  {section.description}
                </Typography>
              </Box>

              {/* Description for mobile */}
              <Typography
                variant="h5"
                fontFamily="Inter"
                sx={{
                  display: { xs: 'block', md: 'none' },
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#C0C0C0',
                  mt: '12px',
                  textAlign: 'center'
                }}
              >
                {section.description}
              </Typography>
            </Box>
          );
        })}
      </Box>
      <Box sx={{ paddingBottom: { xs: 0, md: 3 } }}></Box>

      <Box
        sx={{
          mt: 0,
          [theme.breakpoints.down('md')]: {
            mt: 0
          }
        }}
      >
        <ListArtstyleButton
          maxWidth={isMdOrBelow ? '131px' : '200px'}
          maxHeight={isMdOrBelow ? '49px' : '52px'}
          fontSize={isMdOrBelow ? '14px' : '16px'}
          padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
          marginTop={{ xs: '40px', sm: '40px' }}
        />
        <Box sx={{ paddingBottom: { xs: '40px', md: 11 } }}></Box>
      </Box>
    </Box>
  );
};
